<template>
  <div class="app-inner">
    <el-tabs v-model="activeName">
        <el-tab-pane label="所有" name="queryAll"/>
        <el-tab-pane label="份额待审核" name="queryAgriculturalAge"/>
        <!-- <el-tab-pane label="股份份额待审核" name="queryShare"/> -->
    </el-tabs>
    <all-info v-if="activeName === 'queryAll'"/>
    <examine-age v-if="activeName === 'queryAgriculturalAge'"/>
    <examine-share v-if="activeName === 'queryShare'"/>
  </div>
</template>

<script>
import AllInfo from './allInfo.vue'
import ExamineAge from './examineAge.vue'
import ExamineShare from './examineShare.vue'
export default {
  data () {
    return {
      activeName: 'queryAll'
    }
  },
  components: {
    AllInfo,
    ExamineAge,
    ExamineShare
  }
}
</script>